/*import React from 'react'
import Helmet from 'react-helmet'

const ProtectionsCoveragesEn = () => (
  <div className="page protections_coverages">
  <Helmet
            title={`Budget Nicaragua protections & Coverages - Find a Car Rental Near You`}
            meta={[
              {
                name: 'description',
                content:
                  'Frequently Asked Questions about car rentals.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'en',
                href:
                  './es/protections-coverages',
              },
            ]}
          />
    <div className="image"></div>
    <h1>Protections & Coverages</h1> 
    <div>
      <div>
      <ul>
          <li>
          <h2>C1 (SLI)</h2>
          <h3>U$12.99 daily</h3>
          <p>
          Third Party Responsibility Coverage. MANDATORY. Maximum amount of coverage: US$15000. Deductible: 20%. Valid only in Nicaragua.
          </p>
          </li>
          <li>
          <h2>C2 (CDW + SLI)</h2>
          <h3>US$22.99 daily</h3>
          <p>
            Partial coverage in case of damage for collision o robbery of the whole car. Deductible:<br/>
          * US$1,000 in case of collision damages.<br/>
          * 20% in case of robbery of the car (It does not cover robbery of parts of the car).<br/>
          Third Party Responsibility Coverage.<br/>
          Maximum amount of coverage: US$15000.<br/>
          Deductible: 20%.<br/>
          Valid only in Nicaragua.
          </p>
          </li>
          <li>
          <h2>C3 (CDW + CLP + SLI)</h2>
          <h3>US$32.99 daily</h3>
          <p>It waives all responsibility in case of damage for collision, and partially in case of robbery of the whole car. Deductible:<br/>
          * 0 in case of collision damages<br/>
          * 20% in case of robbery of the car (It does not cover robbery of parts of the car).<br/>
          Windshield and Tires Waiver.<br/>
          It protects in case of damage to tires and front windshield.<br/>
          It does not cover robbery.<br/>
          Third Party Responsibility Coverage.<br/>
          Maximum amount of coverage: US$15000.<br/>
          Deductible: 20%.<br/>
          Valid only in Nicaragua.
          </p>
          </li>
          <li>
          <h2>C4 (CDW + CLP + SLI + CDP + PIA + CAC + ACD)</h2>
          <h3>US$52.99 daily</h3>
          <p>
          Total exemption in case of collision damage and 80% in case of total theft of the vehicle.<br/>
          Civil Liability coverage to third parties. Maximum coverage: US $ 15,000. Deductible: 20%<br/>
          Covers damage to tires and damages to all the windows of the vehicle.<br/>
          Additionally, this coverage protects the customer in case of scratches, scrapes, dents, damage to: keyholes, antennas, hands, side mirrors, stops and other damages to the vehicle’s body. It covers partial thefts and damages inside the vehicle.<br/>
          For this coverage the company will assume a maximum of US $ 500.00. If the amount of the damage exceeds this value the client will pay the surplus.<br/>
          It includes Individual Protection by accident to the passengers of the Budget vehicle. Reimbursement of medical expenses up to an amount of US5,000 for the total number of passengers in the vehicle, provided they do not exceed the capacity of the vehicle.<br/>
          Road Assistance Coverage included. Protects outside the national territory and assonated in Nicaragua.<br/>
          </p>
          </li>
          <li>
          <h2>C5 (CDW + CLP + SLI + CDP + PIA)</h2>
          <h3>US$39.99 daily</h3>
          <p>
          Total exemption in case of collision damage and 80% case of total theft of the vehicle.<br/>
          Civil Liability coverage to third parties. Maximum coverage: US $ 15,000. Deductible: 20%<br/>
          Covers damage to tires and damages all the windows of the vehicle.<br/>
          Additionally, it protects the customer in case of scratches, scrapes, dents, damage to: keyholes, antennas, side and rear windows, hands, side mirrors, stops and other damages to the vehicle body. For this coverage the company will assume a maximum of US $ 500.00.<br/>
          If the amount of the damage exceeds this value the client will pay the surplus. Does not cover partial theft or damage to the interior of the vehicle.<br/>
          It includes Individual Protection by accident to the passengers of the Budget vehicle. Reimbursement of medical expenses up to an amount of US $ 5,000 for the total number of passengers in the vehicle, provided that they do not exceed the capacity of the vehicle.<br/>
          </p>
          </li>
          <li>
          <h2>Full Cover (CDW + CLP + SLI + CDP + PIA + CAC + ACD)</h2>
          <h3>US$44.99 daily</h3>
          <p>
          Total exemption in case of collision damage and 80% in case of total theft of the vehicle.<br/>
          Civil Liability coverage to third parties. Maximum coverage: US $ 15,000. Deductible: 20%<br/>
          Covers damage to tires and damages all the glasses of the vehicle.<br/>
          Additionally, this coverage protects the customer in case of scratches, scrapes, dents, damage to: keyholes, antennas, hands, side mirrors, stops and other damages to the vehicle body. It covers partial thefts and damages inside the vehicle.<br/>
          For this coverage the company will assume a maximum of US $ 500.00. If the amount of the damage exceeds this value the client will pay the surplus.<br/>
          It includes Individual Protection by accident to the passengers of the Budget vehicle. Reimbursement of medical expenses up to an amount of US5,000 for the total number of passengers in the vehicle, provided they do not exceed the capacity of the vehicle.<br/>
          Road Assistance Coverage included.
          </p>
          </li>
          <li>
          <h2>Coverage PIA</h2>
          <h3>US$3.99 daily</h3>
          <p>
          It gives protection to Budget vehicle passengers.<br/>
          Refund of medical expenses up to an amount of US$5000, independently of the number of passengers in the rented vehicle that do not exceed the vehicle capacity.<br/>
          It applies out of the country if C4 is taken.
          </p>
          </li>
          <li>
          <h2>Coverage CLP</h2>
          <h3>US$5.00 daily</h3>
          <p>
          Windshield and Tires Waiver.<br/>
          It protects in case of damage to tires and front windshield.<br/>
          It does not cover robbery.<br/>
          It applies out of the country if C4 is taken.<br/>
          </p>
          </li>

          <li>
          <h2>Coverage CAC</h2>
          <h3>US$3.50 daily</h3>
          <p>
          Roads Assistance Coverage. You will be given assistance in case of an unexpected difficulty or emergency 24 hours a day.<br/>

          Requirements:<br/>
          If you want to make the coverages effective you must call Budget Rent a Car at the moment of the accident and present a Police Certificate.<br/>
          Any protection does not cover you in case of:<br/>

          <li>Any violation of the rental agreement.</li>
          <li>The driver is under the influence of alcohol, drugs or committing any illegal act.</li>
          <li>Violation of the speed limits.</li>
          </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
)
export default ProtectionsCoveragesEn

*/



import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'


class ProtectionsCoveragesEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionEn: '',
    }

    this.renderTextsCoverage = this.renderTextsCoverage.bind(this)

    
  }
  componentDidMount() {


      axios
      .get(`${backendURL}/api/texts/sections/TextCovertura/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionEn:{
            en: txt.descriptionEn,
          }, 
        })
        })

     

      .catch(err => {
        console.log(err)
      })
  }


  renderTextsCoverage() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionEn , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>
          <p> 
            {descriptionEn.en} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'en',
             href:
               './es/corporate_program',
           },
         ]}
       />
       <div className="image"></div>
       <h1>Protections & Coverages</h1>
    <div dangerouslySetInnerHTML={{__html: this.state.descriptionEn.en}}></div>
</div>
    )
  }
}

export default ProtectionsCoveragesEn


// WEBPACK FOOTER //
// ./src/pages/protections-coverages.en.js